// src/components/Header/index.tsx
import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Container,
  Box,
  Typography,
  IconButton,
  Button,
  Collapse,
  Divider,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { alpha } from "@mui/material/styles";
import { LoginModal } from "../LoginModal";
import { UserBar } from "./UserBar";
import { Brand } from "./Brand";

type HeaderProps = {
  logoSrc?: string;
  onCountriesClick?: () => void; // 👈 nuevo
};

export const Header: React.FC<HeaderProps> = ({
  logoSrc,
  onCountriesClick,
}) => {
  const [showMenu, setShowMenu] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);

  const links = [
    { linkName: "Login / Register", linkAction: () => setShowLoginModal(true) },
  ];

  return (
    <>
      <LoginModal open={showLoginModal} setOpen={setShowLoginModal} />

      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          backgroundColor: (t) => alpha(t.palette.common.black, 0.75),
          backdropFilter: "blur(10px)",
          borderBottom: (t) =>
            `1px solid ${alpha(t.palette.common.white, 0.08)}`,
        }}
      >
        <Container maxWidth={false}>
          <Toolbar
            disableGutters
            sx={{
              minHeight: 64,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 2,
              color: "common.white",
            }}
          >
            {/* Marca */}
            <Box
              onClick={() => (window.location.href = "/")}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.25,
                cursor: "pointer",
              }}
            >
              {logoSrc ? (
                <Box
                  component="img"
                  src={logoSrc}
                  alt="BestEuroGirls"
                  sx={{ height: 28 }}
                />
              ) : (
                <Brand />
              )}
            </Box>

            <UserBar />
            {/* Botones desktop */}
            <Box
              sx={{
                display: { xs: "none", md: "flex" },
                alignItems: "center",
                gap: 1.25,
              }}
            >
              {/* {links.map((l, i) => (
                <Button
                  key={i}
                  onClick={l.linkAction}
                  variant="outlined"
                  size="small"
                  sx={{
                    color: "common.white",
                    borderColor: (t) => alpha(t.palette.common.white, 0.35),
                    "&:hover": {
                      borderColor: (t) => alpha(t.palette.common.white, 0.6),
                      backgroundColor: (t) =>
                        alpha(t.palette.common.white, 0.06),
                    },
                    borderRadius: 999,
                    px: 2.2,
                    py: 0.75,
                    letterSpacing: 0.6,
                    fontWeight: 600,
                  }}
                >
                  {l.linkName.toUpperCase()}
                </Button>
              ))} */}
            </Box>

          </Toolbar>
          {/* mobile-countries-row: el boton de paises va debajo del logo en celular */}
          <Box sx={{ display: { xs: "flex", md: "none" }, pb: 1.25 }}>
            <Button
                size="small"
                onClick={onCountriesClick} // ✅ this calls the prop
                sx={{
                  color: "common.white",
                  borderRadius: 999,
                  px: 1.8,
                  py: 0.6,
                  border: (t) =>
                    `1px solid ${alpha(t.palette.common.white, 0.35)}`,
                  "&:hover": {
                    backgroundColor: (t) => alpha(t.palette.common.white, 0.06),
                  },
                }}
              >
                Countries
              </Button>
          </Box>
        </Container>

        {/* Menú móvil opcional (otros links) */}
        <Collapse in={showMenu} timeout="auto" unmountOnExit>
          <Divider
            sx={{ borderColor: (t) => alpha(t.palette.common.white, 0.12) }}
          />
          <Box
            sx={{
              backgroundColor: (t) => alpha(t.palette.common.black, 0.8),
              backdropFilter: "blur(6px)",
            }}
          >
            <Container maxWidth="lg">
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  py: 1,
                  gap: 0.5,
                }}
              >
                {/* {links.map((l, i) => (
                  <Button
                    key={i}
                    onClick={() => {
                      setShowMenu(false);
                      l.linkAction();
                    }}
                    sx={{
                      justifyContent: "flex-start",
                      color: "common.white",
                      py: 1.25,
                      "&:hover": {
                        backgroundColor: (t) =>
                          alpha(t.palette.common.white, 0.06),
                      },
                    }}
                  >
                    {l.linkName}
                  </Button>
                ))} */}
              </Box>
            </Container>
          </Box>
        </Collapse>
      </AppBar>
    </>
  );
};
